import {
  Sprout, Leaf, Droplets, FlaskConical, Microscope, Atom, Layers, MapPinned, ShieldCheck,
  ArrowRight, ArrowUpRight, ArrowLeft, Search, X, Menu, ChevronDown, ChevronRight, ChevronLeft,
  Plus, Minus, Phone, Mail, MapPin, MessageCircle, Check, CheckCircle2, AlertCircle, Download,
  ExternalLink, SlidersHorizontal, Sun, Wheat, Recycle, HeartHandshake, Sparkles, TestTube,
  Package, Ruler, ShieldAlert, Info, Quote, Loader2, Send, Building2, Users, Handshake,
  FlaskRound, Gauge, Beaker, ThermometerSun, FileText, BookOpen, Library, GraduationCap,
  type LucideIcon,
} from 'lucide-react'

const registry: Record<string, LucideIcon> = {
  Sprout, Leaf, Droplets, FlaskConical, Microscope, Atom, Layers, MapPinned, ShieldCheck,
  ArrowRight, ArrowUpRight, ArrowLeft, Search, X, Menu, ChevronDown, ChevronRight, ChevronLeft,
  Plus, Minus, Phone, Mail, MapPin, MessageCircle, Check, CheckCircle2, AlertCircle, Download,
  ExternalLink, SlidersHorizontal, Sun, Wheat, Recycle, HeartHandshake, Sparkles, TestTube,
  Package, Ruler, ShieldAlert, Info, Quote, Loader2, Send, Building2, Users, Handshake,
  FlaskRound, Gauge, Beaker, ThermometerSun, FileText, BookOpen, Library, GraduationCap,
}

interface IconProps {
  name: string
  className?: string
  strokeWidth?: number
  style?: React.CSSProperties
}

export function Icon({ name, className = 'h-5 w-5', strokeWidth = 1.75, style }: IconProps) {
  const Cmp = registry[name] ?? Leaf
  return <Cmp className={className} strokeWidth={strokeWidth} style={style} aria-hidden="true" />
}
